import {
	TICKET_CREATE,
	TICKET_UPDATE,
	TICKET_DELETE,
	TICKET_CANCEL,
	TICKET_FETCH,
	TICKET_VERIFIED_UPDATE,
	TICKETS_FETCH,
	TICKETS_SERVICE_FETCH,
	TICKETS_SHOWROOM_FETCH,
	TICKETS_HOTSHEET_SERVICE_FETCH,
	TICKETS_HOTSHEET_SHOWROOM_FETCH,
	TICKETS_CALLCENTER_SERVICE_FETCH,
	TICKETS_CALLCENTER_SHOWROOM_FETCH,
	TICKETS_SERVICE_REPORT_STATUS_FETCH,
	TICKETS_SHOWROOM_REPORT_STATUS_FETCH,
	TICKETS_HOTSHEET_SERVICE_REPORT_STATUS_FETCH,
	TICKETS_HOTSHEET_SHOWROOM_REPORT_STATUS_FETCH,
	TICKETS_CALLCENTER_SERVICE_REPORT_STATUS_FETCH,
	TICKETS_CALLCENTER_SHOWROOM_REPORT_STATUS_FETCH,
	TICKET_FETCH_SUCCESS,
	TICKETS_FETCH_SUCCESS,
	TICKETS_SERVICE_FETCH_SUCCESS,
	TICKETS_SHOWROOM_FETCH_SUCCESS,
	TICKETS_HOTSHEET_SERVICE_FETCH_SUCCESS,
	TICKETS_HOTSHEET_SHOWROOM_FETCH_SUCCESS,
	TICKETS_CALLCENTER_SERVICE_FETCH_SUCCESS,
	TICKETS_CALLCENTER_SHOWROOM_FETCH_SUCCESS,
	TICKETS_SERVICE_REPORT_STATUS_FETCH_SUCCESS,
	TICKETS_SHOWROOM_REPORT_STATUS_FETCH_SUCCESS,
	TICKETS_HOTSHEET_SERVICE_REPORT_STATUS_FETCH_SUCCESS,
	TICKETS_HOTSHEET_SHOWROOM_REPORT_STATUS_FETCH_SUCCESS,
	TICKETS_CALLCENTER_SERVICE_REPORT_STATUS_FETCH_SUCCESS,
	TICKETS_CALLCENTER_SHOWROOM_REPORT_STATUS_FETCH_SUCCESS,
	TICKET_FETCH_RESET,
	TICKETS_FETCH_RESET,
	TICKETS_SERVICE_FETCH_RESET,
	TICKETS_SHOWROOM_FETCH_RESET,
	TICKETS_HOTSHEET_SERVICE_FETCH_RESET,
	TICKETS_HOTSHEET_SHOWROOM_FETCH_RESET,
	TICKETS_CALLCENTER_SERVICE_FETCH_RESET,
	TICKETS_CALLCENTER_SHOWROOM_FETCH_RESET,
	TICKETS_SERVICE_REPORT_STATUS_FETCH_RESET,
	TICKETS_SHOWROOM_REPORT_STATUS_FETCH_RESET,
	TICKETS_HOTSHEET_SERVICE_REPORT_STATUS_FETCH_RESET,
	TICKETS_HOTSHEET_SHOWROOM_REPORT_STATUS_FETCH_RESET,
	TICKETS_CALLCENTER_SERVICE_REPORT_STATUS_FETCH_RESET,
	TICKETS_CALLCENTER_SHOWROOM_REPORT_STATUS_FETCH_RESET,
	TICKETS_EXPORT_EXCEL,
	TICKET_LOGS_UPDATE,
} from "./types";

export const ticketFetch = id => {
	return {
		type: TICKET_FETCH,
		payload: id
	};
};

export const ticketFetchSuccess = payload => {
	return {
		type: TICKET_FETCH_SUCCESS,
		payload: payload
	};
};

export const ticketFetchReset = () => {
	return {
		type: TICKET_FETCH_RESET
	};
};

export const ticketsFetch = payload => {
	return {
		type: TICKETS_FETCH,
		payload: payload
	};
};

export const ticketsFetchSuccess = payload => {
	return {
		type: TICKETS_FETCH_SUCCESS,
		payload: payload
	};
};

export const ticketsFetchReset = () => {
	return {
		type: TICKETS_FETCH_RESET
	};
};

export const ticketsShowroomFetch = payload => {
	return {
		type: TICKETS_SHOWROOM_FETCH,
		payload: payload
	};
};

export const ticketsShowroomFetchSuccess = payload => {
	return {
		type: TICKETS_SHOWROOM_FETCH_SUCCESS,
		payload: payload
	};
};

export const ticketsShowroomFetchReset = () => {
	return {
		type: TICKETS_SHOWROOM_FETCH_RESET
	};
};

export const ticketsServiceFetch = payload => {
	return {
		type: TICKETS_SERVICE_FETCH,
		payload: payload
	};
};

export const ticketsServiceFetchSuccess = payload => {
	return {
		type: TICKETS_SERVICE_FETCH_SUCCESS,
		payload: payload
	};
};

export const ticketsServiceFetchReset = () => {
	return {
		type: TICKETS_SERVICE_FETCH_RESET
	};
};

export const ticketsServiceReportStatusFetch = payload => {
	return {
		type: TICKETS_SERVICE_REPORT_STATUS_FETCH,
		payload: payload
	};
};

export const ticketsServiceReportStatusFetchSuccess = payload => {
	return {
		type: TICKETS_SERVICE_REPORT_STATUS_FETCH_SUCCESS,
		payload: payload
	};
};

export const ticketsServiceReportStatusFetchReset = () => {
	return {
		type: TICKETS_SERVICE_REPORT_STATUS_FETCH_RESET
	};
};

export const ticketsShowroomReportStatusFetch = payload => {
	return {
		type: TICKETS_SHOWROOM_REPORT_STATUS_FETCH,
		payload: payload
	};
};

export const ticketsShowroomReportStatusFetchSuccess = payload => {
	return {
		type: TICKETS_SHOWROOM_REPORT_STATUS_FETCH_SUCCESS,
		payload: payload
	};
};

export const ticketsShowroomReportStatusFetchReset = () => {
	return {
		type: TICKETS_SHOWROOM_REPORT_STATUS_FETCH_RESET
	};
};
// ------------------------------------------------------------
export const ticketsHotSheetShowroomFetch = payload => {
	return {
		type: TICKETS_HOTSHEET_SHOWROOM_FETCH,
		payload: payload
	};
};

export const ticketsHotSheetShowroomFetchSuccess = payload => {
	return {
		type: TICKETS_HOTSHEET_SHOWROOM_FETCH_SUCCESS,
		payload: payload
	};
};

export const ticketsHotSheetShowroomFetchReset = () => {
	return {
		type: TICKETS_HOTSHEET_SHOWROOM_FETCH_RESET
	};
};

export const ticketsHotSheetServiceFetch = payload => {
	return {
		type: TICKETS_HOTSHEET_SERVICE_FETCH,
		payload: payload
	};
};

export const ticketsHotSheetServiceFetchSuccess = payload => {
	return {
		type: TICKETS_HOTSHEET_SERVICE_FETCH_SUCCESS,
		payload: payload
	};
};

export const ticketsHotSheetServiceFetchReset = () => {
	return {
		type: TICKETS_HOTSHEET_SERVICE_FETCH_RESET
	};
};

export const ticketsHotSheetServiceReportStatusFetch = payload => {
	return {
		type: TICKETS_HOTSHEET_SERVICE_REPORT_STATUS_FETCH,
		payload: payload
	};
};

export const ticketsHotSheetServiceReportStatusFetchSuccess = payload => {
	return {
		type: TICKETS_HOTSHEET_SERVICE_REPORT_STATUS_FETCH_SUCCESS,
		payload: payload
	};
};

export const ticketsHotSheetServiceReportStatusFetchReset = () => {
	return {
		type: TICKETS_HOTSHEET_SERVICE_REPORT_STATUS_FETCH_RESET
	};
};

export const ticketsHotSheetShowroomReportStatusFetch = payload => {
	return {
		type: TICKETS_HOTSHEET_SHOWROOM_REPORT_STATUS_FETCH,
		payload: payload
	};
};

export const ticketsHotSheetShowroomReportStatusFetchSuccess = payload => {
	return {
		type: TICKETS_HOTSHEET_SHOWROOM_REPORT_STATUS_FETCH_SUCCESS,
		payload: payload
	};
};

export const ticketsHotSheetShowroomReportStatusFetchReset = () => {
	return {
		type: TICKETS_HOTSHEET_SHOWROOM_REPORT_STATUS_FETCH_RESET
	};
};
// ------------------------------------------------------------
export const ticketsCallCenterShowroomFetch = payload => {
	return {
		type: TICKETS_CALLCENTER_SHOWROOM_FETCH,
		payload: payload
	};
};

export const ticketsCallCenterShowroomFetchSuccess = payload => {
	return {
		type: TICKETS_CALLCENTER_SHOWROOM_FETCH_SUCCESS,
		payload: payload
	};
};

export const ticketsCallCenterShowroomFetchReset = () => {
	return {
		type: TICKETS_CALLCENTER_SHOWROOM_FETCH_RESET
	};
};

export const ticketsCallCenterServiceFetch = payload => {
	return {
		type: TICKETS_CALLCENTER_SERVICE_FETCH,
		payload: payload
	};
};

export const ticketsCallCenterServiceFetchSuccess = payload => {
	return {
		type: TICKETS_CALLCENTER_SERVICE_FETCH_SUCCESS,
		payload: payload
	};
};

export const ticketsCallCenterServiceFetchReset = () => {
	return {
		type: TICKETS_CALLCENTER_SERVICE_FETCH_RESET
	};
};

export const ticketsCallCenterServiceReportStatusFetch = payload => {
	return {
		type: TICKETS_CALLCENTER_SERVICE_REPORT_STATUS_FETCH,
		payload: payload
	};
};

export const ticketsCallCenterServiceReportStatusFetchSuccess = payload => {
	return {
		type: TICKETS_CALLCENTER_SERVICE_REPORT_STATUS_FETCH_SUCCESS,
		payload: payload
	};
};

export const ticketsCallCenterServiceReportStatusFetchReset = () => {
	return {
		type: TICKETS_CALLCENTER_SERVICE_REPORT_STATUS_FETCH_RESET
	};
};

export const ticketsCallCenterShowroomReportStatusFetch = payload => {
	return {
		type: TICKETS_CALLCENTER_SHOWROOM_REPORT_STATUS_FETCH,
		payload: payload
	};
};

export const ticketsCallCenterShowroomReportStatusFetchSuccess = payload => {
	return {
		type: TICKETS_CALLCENTER_SHOWROOM_REPORT_STATUS_FETCH_SUCCESS,
		payload: payload
	};
};

export const ticketsCallCenterShowroomReportStatusFetchReset = () => {
	return {
		type: TICKETS_CALLCENTER_SHOWROOM_REPORT_STATUS_FETCH_RESET
	};
};
// ------------------------------------------------------------
export const ticketCreate = values => {
	return {
		type: TICKET_CREATE,
		payload: values
	};
};

export const ticketUpdate = values => {
	return {
		type: TICKET_UPDATE,
		payload: values
	};
};

export const ticketVerifiedUpdate = values => {
	return {
		type: TICKET_VERIFIED_UPDATE,
		payload: values
	}
};

export const ticketDelete = id => {
	return {
		type: TICKET_DELETE,
		payload: id
	};
};

export const ticketCancel = values => {
	return {
		type: TICKET_CANCEL,
		payload: values
	};
}

export const ticketsExportExcel = payload => {
	return {
		type: TICKETS_EXPORT_EXCEL,
		payload: payload
	};
};

export const ticketLogsUpdate = payload => {
	return {
		type: TICKET_LOGS_UPDATE,
		payload: payload
	};
};